export default __webpack_public_path__ + "static/media/workers.80a12b5d.jpg";